import { Kategori } from '../types/dtos/VarderingarModel';

interface EnabledParameters {
  boarea: boolean;
  biarea: boolean;
  antalRum: boolean;
  tomt: boolean;
  standardpoang: boolean;
  byggar: boolean;
  avgift: boolean;
  vaning: boolean;
  antalVaningar: boolean;
}

const enabledParametersSmahus: Partial<EnabledParameters> = {
  vaning: false,
  antalVaningar: false,
  avgift: false,
};

const enabledParametersBostadsratt: Partial<EnabledParameters> = {
  tomt: false,
};

const allEnabled = {
  boarea: true,
  biarea: true,
  antalRum: true,
  tomt: true,
  standardpoang: true,
  byggar: true,
  avgift: true,
  vaning: true,
  antalVaningar: true,
};

const noneEnabled = Object.keys(allEnabled).reduce(
  (acc, val) => ({ ...acc, [val]: false }),
  {} as EnabledParameters
);

export const getEnabledParameters = (
  bostadskategori: Kategori
): EnabledParameters =>
  ({
    [Kategori.SMAHUS]: { ...allEnabled, ...enabledParametersSmahus },
    [Kategori.BOSTADSRATT]: { ...allEnabled, ...enabledParametersBostadsratt },
  }[bostadskategori] || noneEnabled);
